module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "sp",
    attrs: {
      "id": "ch3"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "CN"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contents#c_ch3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("THREE")])])]), _vm._v(" "), _c('p', {
    staticClass: "Chap-Title-ct"
  }, [_vm._v("M"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("ANHATTAN")])]), _vm._v(" "), _c('p', {
    staticClass: "Dateline-Chapter-dl"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Wednesday, September 6, 2000")])]), _vm._v(" "), _c('p', {
    staticClass: "Head-Level-1-h1"
  }, [_vm._v("S"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("OPHIE")])]), _vm._v(" "), _c('p', {
    staticClass: "CO"
  }, [_vm._v("Sophie runs up the stairwell of the "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("New York Times")]), _vm._v("’ offices on West Forty-third Street, the exhilaration of her ride across the Williamsburg Bridge into Manhattan still with her, her cheeks flushed with pink. The stale scent of cigarette smoke hangs on the air in the hall as she pushes open the door. “Hey,” she says to one of the interns on the way through the dingy, windowless newsroom. “Is the boss in yet?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Not yet, Soph.” The boy flexes his wrist and winces.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“RSI playing up, still?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Yeah, and the culture editor wants me to be his hands today.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("She roots around in her bag and tosses him a gold pot. “Tiger Balm helps. Weren’t you on the TV guide? Those grids are a killer.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“They’re kind of boring.…”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Shh!” Sophie’s eyes widen. “For God’s sake don’t let anyone hear you say that. You’ve got to suck it up, we’ve all been there.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Sophie glances around for any sign of her boss as she walks on through the office. “Thank God,” she says under her breath as she reaches her desk safely. She slings her satchel onto the back of her chair and swivels around to the computer just as the phone rings. “Sophie Cass,” she answers, crooking the receiver against her shoulder as she begins to type. She waves her hand, clearing the cloud of fruit flies hovering above the bowl of red apples by her computer.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Cass,” he says. The hum of the strip lights and tap of keyboards across the room seem to intensify.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Wallace,” she says finally, trying to sound amused, playful.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Damn, your voice is sexy as ever.” She can hear his breath on the phone line. “You’re late.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("She eases back in her chair. “I prefer to think of it as making an entrance.” Sophie pauses. “How do you know?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“I always liked you in chinos. Very Hepburn, very yar…”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Are you comparing me to a "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("boat")]), _vm._v("?” She swivels around and stands. Jess is leaning against a desk at the end of the newsroom.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Why not? Trim. Responsive. Lively handling…” He flicks his cell phone closed and walks toward her as she replaces the receiver with deliberate care.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“What a surprise. I didn’t know you were in town.” "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("You didn’t warn me,")]), _vm._v(" she thinks.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“How are you?” He leans down to kiss her cheek, and she smells a new cologne—something citrus and fresh. “You look great.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Thanks. I’ve been at the beach with Mom.” She can’t immediately place what has changed about him. He’s wearing the same deep blue suit she loved the best, his red-blond hair is immaculate, as ever. “Are you here for the summit?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Yeah, I had some leave, so I flew in from Paris last night. Biggest gathering of world leaders in history, never know what I might pick up.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“You never stop, do you?” Sophie indicates the phone. “I should—”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Sure.” He holds her gaze. “Can we have a drink later?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“I don’t know.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Old times’ sake?” He leans over her, searching for a pen. She imagines for a moment reaching out to him, lacing her fingers in his. How simply it could all begin, again. “Around six "), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("P.M.")]), _vm._v("?” Jess scribbles down an address.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Why not?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“See you later, Cass.” As he turns, he calls back, “Don’t be late.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("And then, as he walks away, Sophie realizes. It is not Jess who has changed, it is her.")]), _vm._v(" "), _c('p', {
    staticClass: "SB-STD"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "Space-Break-3-Line-ls3"
  }, [_vm._v("“I’m sorry, I’m sorry…” Sophie waves, running along West Fifty-third Street, her heels clicking. “The meeting ran over.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Well, look at you,” Alisha says. She shoulders open the door to the museum, and they walk against the crowds leaving for the day. “You shouldn’t have gotten all dressed up for me.…”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“I didn’t, I’m meeting—”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Jess.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“How did you know?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“He rang the studio just after you left for work this morning. I hope you know what you’re doing.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Of course I don’t.” Sophie smooths down her black dress. “Do I look okay?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“You look beautiful. Hold on a second.” Alisha reaches around to the nape of Sophie’s neck and snaps off the tag. “Don’t want him to think you’re making a special effort or anything.” She screws it up and tosses it into a bin without breaking her stride.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Oh God, I didn’t?” She touches her neck.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“You did.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Anyway, it’s not for Jess. I bought it for tomorrow. I just thought I might as well wear it now. At least he won’t be able to complain I didn’t make an effort.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Alisha takes a breath. “Where are you meeting him?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Some cigar bar up on First and Forty-eighth.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Typical. Convenient for his parents’ place?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Don’t start.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Listen, I have seen you put yourself back together again over the last few months and it has been hard for you. He comes breezing in from Paris and you—”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“It’s just a drink. That’s all. It’s over. I just—I just want to make sure he’s doing okay.” They walk on through the museum, and Sophie checks her watch. “So what did you want to show me?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“I want you to know what you’re up against.” Alisha points the way, the gold bracelets on her wrist jangling. “When I was in here the other day I saw they’d done a rehang. I guess your Mr. Lambert’s due for a revival with his birthday coming up and all.” She glances across as a young guard walks toward them.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“The museum is closing,” he says.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Okay, honey.” Alisha tosses a glance over her shoulder like a silk scarf as she walks on. “Over here,” she says to Sophie, stopping in front of a series of huge dark paintings, broad abstract strokes gouging into the canvas. “Gabriel Lambert.” They stand side by side in silence. “I know this isn’t your period—”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Sophie squints at the Perspex tag on the wall: "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Mars")]), _vm._v(". “Give me a Matisse or Monet’s water lilies any day,” she says quietly, stepping backward to take in the full scale of the paintings.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Lambert makes the rest of them—Pollock, Rothko, all those abstract expressionists of the fifties—well, he makes them look like pussycats.” Alisha sweeps her arm around the gallery, and Sophie turns a full circle, returning to Lambert. She stands in silence for a time, dwarfed by the paintings. It feels as though they are pressing down on her.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“We should go,” Alisha says, noticing they are the last ones in the gallery.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“The thing is,” Sophie says, pointing out canvases as they walk on through the museum, “these guys—the Europeans like Breton and Ernst, all the people Varian Fry helped escape from France, when they arrived in America it was like art exploded. They were the catalyst for all of that.” She points back to the room with the abstract expressionists. “But Lambert’s work changed so much, I just don’t get it.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Well, if you ask him why, you’re a braver woman than me. Your man’s like the missing link, isn’t he? Born in France and made in America.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“I came into the archives here a while back, and looked at the ‘Flight’ portfolio of prints Varian Fry curated to raise funds for the refugee organization he worked for back during the war. I don’t understand why so few of the artists he helped contributed work.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Did Lambert?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Nope.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Doesn’t surprise me. He’s a tough old SOB.” Alisha pauses on the pavement, and Sophie hears the museum doors locking behind them.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Maybe after everything he went through during World War Two he didn’t want to look back,” Sophie says, thinking it through.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Perhaps once you start running, it’s hard to ever stay still.” Alisha puts her hands on her hips. “Look, don’t let this old guy run rings round you. From what I’ve heard he’s tricksy. Did I tell you he blanked me at an opening once?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“No? When was that?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Way back, way, way back. I was still at Parsons. It was a friend’s show—I saw this old guy in a denim shirt and worn-out jeans, and espadrilles with his toes poking out of a hole at the front, and I thought: I know you. I mean, his hair was white as white, but those eyes … like those snow dogs, you know? Ice blue.” Alisha whistles softly. “Man, he must have been fine in his day.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“So what happened?’")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“I went over—you know me, I’ll talk to anyone, and I started in with: ‘Excuse me, Mr. Lambert, I just wanted to let you know what your work has meant to me.…’”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“And?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“He just stared me down. Those goddamn beautiful eyes, cold as fire.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“That doesn’t make sense.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“It will when you meet him. Hot and icy, all at the same time. He just walked on by me midsentence, gushing like a damn fool about how much I loved his work.” Alisha shakes her head. “Take my advice. You want your story, keep it professional. Don’t show a chink of weakness—”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“I won’t.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Sophie, you’re a romantic.” Alisha cups her face between her hands. “I know you’ve fallen for the story of Gabe and Annie Lambert, their mythical lifelong love affair—” Sophie rolls her eyes. “Okay, okay.” Alisha holds up her hands in surrender. “You sure you want to see Jess? I’m going to see "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Love and Sex.…")]), _vm._v("”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Again?” Sophie laughs. “You and your thing for Jon Favreau.” She kisses Alisha’s cheek and walks on. “You’re obsessed.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Takes one to know one,” Alisha says under her breath as Sophie walks away.")]), _vm._v(" "), _c('p', {
    staticClass: "SB-STD"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "Space-Break-3-Line-ls3"
  }, [_vm._v("Jess is reading a copy of "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Wonder Boys,")]), _vm._v(" a plume of blue smoke rising from the cigar in his right hand. Sophie walks toward him through the dimly lit bar, conversation humming around her like bees in dense grass. Jess throws aside the book and taps his Rolex as he unfolds himself from the dark leather wingback chair to greet her.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Give me a break,” Sophie says, kissing his cheek.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Jess gazes down at her. “I’d forgotten how beautiful you are.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“That didn’t take long.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“You cut your hair? I always loved—” He stops, registering her frown.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("She remembers how light and free she felt the night Alisha cut it for her a few weeks ago, the heavy hanks of waist-length hair drifting to the floor. “I like it.” She touches the nape of her neck.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Fresh start?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“I had a broken heart, didn’t you hear?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“You and me both.” His gaze travels down. “You should wear this tomorrow, you know. You look professional.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“I was aiming for irresistible.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Jess smiles, his blue eyes creasing. “That too.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“How do you know about tomorrow?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“I was talking to your editor about this arts story you’re writing.” He settles back in his seat and beckons over the waiter.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Sophie tosses down her bag and takes the chair beside him. “I feel like a kid with a bad report card.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Don’t sound so defeated. Show them what you’re capable of.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Jess, I’m not like you.” Sophie rests her head against the palm of her hand. “I’ve tried, I really have, but I just feel like a phony—”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Sweetheart, I’ve always told you—fake it till you make it—”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“You didn’t just ‘sweetheart’ me?” Sophie raises an eyebrow.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Sorry, sorry!” Jess holds up his hands in defeat. “Damn, forgetting who I’m talking to.” It’s an old joke they share. The moment’s tinged with loss.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Maybe I should have stayed on at the university,” Sophie says, breaking the tension.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Ironic, isn’t it. If you were still at the Sorbonne, we’d be together in Paris now.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Really? I hadn’t thought of that.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“I see your biting wit hasn’t left you.” Jess looks up at the waiter. “What’ll you have?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Sophie takes a sip of his drink and pulls a face. “Neat vodka?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Whiskey started giving me killer hangovers. I miss it, though—few things finer than late nights and Scotch.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Hemingway wannabe.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Pseudo-Sontag.” He holds her gaze. “Chablis?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Sancerre, thanks.” She smiles at the waiter. Jess takes a drag on his cigar and exhales, tilting his face to the ceiling.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Bravo,” he says.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Sorry?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Your taste, it’s refining.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“It suits you, this place.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Sophisticated? Old school?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Expensive. Up its own ass.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“I see you’ve forgiven me.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“And old. Not old school.” Sophie glances at him, smiles. “How was your fortieth?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Lonely.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“I don’t believe that for a moment.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“I missed your birthday, too. What was it? Your twenty-fourth?” Sophie nods. “Well, Happy Birthday to us.” He raises his glass to her as the waiter hands her the wine, and they chink a toast. Jess offers her the cigar.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“I gave up.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Doesn’t count.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Sophie takes a drag, exhales slowly. “Happy?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Not really. You know me.” The intensity of his gaze makes her head spin. “How are you?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Just dandy, can’t you tell?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“And Mutt?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Doing fine; he’s doing just fine.” Sophie hands back the cigar. “You know you have visitation rights, anytime.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Weekends and holidays?” Jess shakes his head, drains his vodka. “No thanks. It was hard enough saying good-bye the first time. Does he still hog the bed?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“He prefers his basket to Alisha’s sofa.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“May I get you a refill, sir?” The waiter clears Jess’s glass.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Yes.” He frowns, waits for him to leave. “Soph, why haven’t you found anywhere yet?” Jess leans toward her.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“I’ve been busy. And you know how expensive it is.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Christ, I feel terrible. Where is it Alisha lives? Williamsburg?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“It’s hardly roughing it.” Sophie laughs. “It’s up-and-coming, you know.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Yeah, if you’re a meth dealer.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“You watch. It’ll be wall-to-wall artisanal cheese shops before you know it.” She shrugs. “It’s not Greenwich Village, but…”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“I’m sorry about that, leaving you to sort the apartment out.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“It was fine,” Sophie says. "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Fine. It’s all fine.")]), _vm._v(" How many times has she said that over the last weeks, when it’s been anything but? "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("It’s been hell, Jess,")]), _vm._v(" that’s what she wants to say. "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("I missed you, and my heart’s still mending.")]), _vm._v(" Her throat tightens at the thought of their home, the cozy rooms she had spent months painting and furnishing, all the hopes and dreams that came to nothing.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“I want you to have some of the money, Soph.” He glances at the waiter. “Thanks.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“No,” she says.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Everything you did to the place added thousands.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Your parents bought it for you—”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“For us.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“And we broke off the wedding.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Only because I insisted on taking the job in Paris.” Jess waits for her to look at him. “I’ve missed you.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Don’t, Jess. We’ve been over this a thousand times. My life is here.” Her stomach flips over at the memory of the arguments toward the end. “What did you expect? That I’d just sacrifice everything and follow you?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“That’s what people in love do.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Would you do it for me?” She waits, part of her still hoping. “I didn’t think so.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Jess swirls his drink. “Your dad would be proud of you.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Don’t, please.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“No, I admire you, I really do.” Jess knocks back his vodka. “Hell of a man to live up to, that father of yours.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Sophie closes her eyes, exhales. “Not this again? Jess, you are the one who wanted to go and be a foreign correspondent—”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“You could have come with me.” He leans forward. “Don’t you remember how it was, when we met? Don’t you remember Paris?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Of course I do.” She can’t look at him.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Soph, I wanted to see you tonight because there’s something I need to tell you—” She picks up on his tone immediately. "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Tell me. Something to tell me, not ask me.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“You’ve met someone new.” It’s a statement, not a question. She places her wine carefully on the table. “Is it serious?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Nothing’s happened, yet.” He takes her hand. “If you won’t come with me—”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Of course. I’m happy for you.” "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("What did I expect?")]), _vm._v(" She rubs her thumb against the side of his, and they rest fingertip to fingertip.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Jeez, Cass. Aren’t we worth more than some job? People do write in Paris, it has been known.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Not like this, not like the "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Times")]), _vm._v("—”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Still going for that Pulitzer, are we? Daddy’s little girl.…”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Be happy, Jess.” Sophie swallows down her disappointment as she stands to leave.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“I’m sorry. Don’t go.” He reaches over to stop her. “I’m flying back just as soon as the UN summit ends on Friday. Once you’ve seen this old guy tomorrow, and knocked out your story—”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Jess, this isn’t just some story.” Sophie squares up to him. “I care about this, more than anything—”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“More than me?” His brow furrows. “Come with me.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“I can’t—”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Just think about it. You’re due some leave, I know.” Sophie tenses as he stands and hugs her. "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Too damn right I am. It should have been our honeymoon.")]), _vm._v(" “Come with me to Paris, not for good, not yet, but just to see if we still—”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Love one another?” Sophie reaches up and kisses his cheek. "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Did you ever really love me? Or were you just in love with the idea of me?")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Stay with me tonight.” He turns to her, his jawbone brushing her temple. “My folks are out of town.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“I can’t—” Her voice breaks. “I just can’t … do this anymore, Jess.” She steps away and smiles, her eyes glistening. “Besides, Mutt’s waiting up for me.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“He watches too much TV. Does he still like "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Friends")]), _vm._v("?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“He’s into "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Frasier")]), _vm._v(" lately.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Is he? I guess we all move on.” Jess gazes down at her. “Stay. Please.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Sophie shakes her head. “I’ve got to be at Penn Station early.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“It’d be quicker if—”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Good-bye, Jess.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“No.” He raises her chin with his index finger.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“What do you mean, no?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“I’m not saying good-bye to you, Cass. Not yet. You’ve got a couple of days to think about it. Montmartre, the galleries, strolling along the Seine … Wait till you see my apartment near Sacré-Cœur.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“You don’t give in, do you?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Never, with you.” Jess drapes her jacket over her shoulders. “One last chance, is that too much to ask?”")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1f27efee","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter3.vue
// module id = 81
// module chunks = 0